import { Box, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import type {
	ClientPortfolioDomainEnum,
	ClientPropertyTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { getPortfolioItemAppearance } from "web_myplann/Portfolio/Helpers/portfolioItemAppearance";
import { IconBox } from "web_myplann/Shared/Components/IconBox";
import { svgMarkupToDataUri } from "web_myplann/Shared/Utils/svgDataUri";

type Props = {
	domain?: ClientPortfolioDomainEnum | null;
	propertyType?: ClientPropertyTypeEnum | null;
	logo?: string | null;
	size?: number;
	glyphSize?: number;
};

export const PortfolioItemIcon: FC<Props> = ({
	domain,
	propertyType,
	logo,
	size = 40,
	glyphSize,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	if (logo) {
		return (
			<IconBox bg={theme.palette.darkmodeText.white} size={size}>
				<Box
					component="img"
					src={svgMarkupToDataUri(logo)}
					alt=""
					sx={{ width: size, height: size, display: "block" }}
				/>
			</IconBox>
		);
	}

	const { bg, color, abbreviation, Icon } = getPortfolioItemAppearance(
		theme.palette,
		t,
		{ domain, propertyType },
	);

	return (
		<IconBox bg={bg} size={size}>
			{abbreviation && (
				<Typography variant="button" color={color}>
					{abbreviation}
				</Typography>
			)}
			{Icon && <Icon size={glyphSize ?? theme.iconSize.md} color={color} />}
		</IconBox>
	);
};
